import React, { useEffect } from "react";
import CommonForm from "../../../utils/commonComponent/commonForm";
import { AddButton, CancelButton, SaveAndUpdate } from "../../../utils/Custom/Button";
import AddIcon from "@mui/icons-material/Add";
import { useParams } from "react-router-dom";
import { fetchQuery } from "../../../utils/commonComponent/fetched";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import Text from "../../../utils/Custom/text";
import MultiAddressInput, { deleteMarkedAddresses, onSubmitAddress } from "./MultiAddressInput";
import { ClassicTable } from "./ClassicTable";
import { BASE_URL, UnicodeCompany } from "../../../global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { readingColumns } from "../../constants/clientConstant";
import axios from "axios";
import { clienTypes } from "../../../utils/commonComponent/common";
import { getPermissions } from "../rbac/hasAccess";

const EditClientMaster = (props) => {
  const params = useParams();
  const permissions = getPermissions(props.moduleId);
  const [inputStates, setInputStates] = React.useState({});
  const [contactDetailsRows, setContactDetailsRowsRows] = React.useState([]);
  const [addressIds, setAddressIds] = React.useState("");
  const [shippingAddressIds, setShippingAddressIds] = React.useState("");
  const [allAddresses, setAllAddresses] = React.useState([]);
  const [deletedAddresses, setDeletedAddresses] = React.useState([]);

  const updateCellValue = (rowIndex, colIndex, value) => {
    const newRows = [...contactDetailsRows];
    newRows[rowIndex][colIndex] = value;
    setContactDetailsRowsRows([...newRows]);
  };

  const addRangeRow = () => {
    let newReadingRows = [...contactDetailsRows];
    newReadingRows.push(["", "", "", ""]);
    setContactDetailsRowsRows([...newReadingRows]);
  };

  const deleteReadingRow = (rowIndex) => {
    let newReadingRows = [...contactDetailsRows];
    if (newReadingRows[rowIndex] != undefined) {
      newReadingRows.splice(rowIndex, 1);
      setContactDetailsRowsRows([...newReadingRows]);
    }
  };
  const updateInputObject = (key, value) => {
    setInputStates((prevInputStates) => ({
      ...prevInputStates,
      [key]: value,
    }));
  };

  const inputFields = [
    {
      type: "Autocomplete",
      label: "Client Type *",
      stateKey: "type",
      options: clienTypes,
      valueKey: "value",
      getOptionLabelKey: "label",
    },
    { type: "TextField", label: "Client Name *", stateKey: "companyName" },
    { type: "TextField", label: "GST", stateKey: "gstNumber" },
    { type: "TextField", label: "UniCode", stateKey: "uniCode", disabled: true },
    { type: "ImageUpload", label: "Logo", stateKey: "logopath" },
  ];

  const fetchClient = async () => {
    try {
      const query = `select * from clients where status = 1 and id = ${params.id}`;
      const [client] = await fetchQuery(query);
      setInputStates(client);
      setAddressIds(client.address);
      setShippingAddressIds(client?.shippingAddress);
      const contacts = client.contact?.trim() ? JSON.parse(client.contact) : [];
      let contactDetailsArray = contacts.map((c) => [
        c.dept,
        c.contactPersonName,
        c.contact,
        c.emailId,
      ]);
      setContactDetailsRowsRows(contactDetailsArray);
    } catch (error) {
      console.error("Error fetching client:", error);
    }
  };

  const getNewUniCode = async () => {
    const [latest] = await fetchQuery(
      `SELECT uniCode FROM clients ORDER BY id DESC LIMIT 1`
    );
    const last = parseInt(latest?.uniCode?.match(/\d+$/)?.[0] || "0", 10);
    updateInputObject(
      "uniCode",
      `${UnicodeCompany}${(last + 1).toString().padStart(3, "0")}`
    );
  };

  const handleSave = () => {
    if (params.id == 0) {
      if (!inputStates.type) {
        toast.error("Client Type is required");
        return;
      }
      if (!inputStates.companyName) {
        toast.error("Client Name is required");
        return;
      }
      if (allAddresses.length == 0) {
        toast.error("At least one address is required");
        return;
      }
      if (contactDetailsRows.length == 0) {
        toast.error("At least one contact is required");
        return;
      }
    }
    if (allAddresses.length > 0) {
      let addressValid = true;
      allAddresses.forEach((addr) => {
        if (!addr.address) {
          addressValid = false;
        }
      });
      if (!addressValid) {
        toast.error("All address fields are required");
        return;
      }
    }
    if (contactDetailsRows.length > 0) {
      let isValid = true;

      contactDetailsRows.forEach((row) => {
        if (
          !row[0] || // dept
          !row[1] || // Contact Person Name
          !row[2] || // Contact No
          !row[3] // Email Id
        ) {
          isValid = false;
        }
      });

      if (!isValid) {
        toast.error("All fields are required for each contact detail");
        return;
      }
    }
    onSubmit();
  };

  const onSubmit = async () => {
    try {
      // First, delete marked addresses if updating existing client
      if (params.id != 0 && deletedAddresses.length > 0) {
        await deleteMarkedAddresses(deletedAddresses);
      }
      const AllIds = await onSubmitAddress(
        allAddresses,
        setShippingAddressIds,
        setAddressIds
      );
      // Build final address strings
      const finalAddressIds = [addressIds, AllIds?.[0]]
        .filter(Boolean)
        .join(",");

      const finalShippingIds = [shippingAddressIds, AllIds?.[1]]
        .filter(Boolean)
        .join(",");

      const rows = contactDetailsRows.map((row) => ({
        dept: row[0] || "",
        contactPersonName: row[1] || "",
        contact: row[2] || "",
        emailId: row[3] || "",
      }));

      const mergedRows = [...rows];

      const jsonData = {
        companyName: inputStates?.companyName || null,
        contact: mergedRows.length > 0 ? JSON.stringify(mergedRows) : null,
        address: finalAddressIds || null,
        shippingAddress: finalShippingIds || null,
        // address:
        //   addressIds && AllIds?.[0]
        //     ? `${addressIds},${AllIds?.[0]}`
        //     : addressIds || AllIds?.[0] || "",
        // shippingAddress:
        //   shippingAddressIds && AllIds?.[1]
        //     ? `${shippingAddressIds},${AllIds?.[1]}`
        //     : shippingAddressIds || AllIds?.[1] || "",
        gstNumber: inputStates?.gstNumber || null,
        state: inputStates.state || null,
        logopath: inputStates.logopath || null,
        email: inputStates.email || null,
        location: inputStates.location || null,
        type: inputStates.type || null,
        ...(params.id === "0" ? { uniCode: inputStates.uniCode || null } : {})
      };

      const url =
        BASE_URL + `clients${params.id !== "0" ? `/${params.id}` : ""}`;

      params.id == 0
        ? await axios.post(url, jsonData)
        : await axios.patch(url, jsonData);

      toast.success(params.id == 0 ? "Clients updated!" : "Client Created!");
      window.location.reload();
    } catch (error) {
      console.log(error.message || "Something Went Wrong!");
    }
  };

  useEffect(() => {
    params.id == 0 ? getNewUniCode() : fetchClient();
  }, []);

  return (
    <>
      <Text variant="h3" bold className="text-blue-600">
        {params.id == 0
          ? "Create New Client"
          : `Update Client ${inputStates?.companyName}`}
      </Text>
      <br />
      <CommonForm
        inputStates={inputStates}
        updateInputObject={updateInputObject}
        inputFields={inputFields}
      />
      <br />
      <MultiAddressInput
        addressIds={addressIds}
        shippingAddressIds={shippingAddressIds}
        setAddressIds={setAddressIds}
        setShippingAddressIds={setShippingAddressIds}
        allAddresses={allAddresses}
        setAllAddresses={setAllAddresses}
        params={params}
        deletedAddresses={deletedAddresses}
        setDeletedAddresses={setDeletedAddresses}
        permissions={permissions}
      />
      <br />
      <br />
      <div className="flex justify-end mb-5">
        <AddButton
          id="btn-add-outline"
          label="Add Contact"
          icon={<AddIcon fontSize="small" />}
          onClick={(e) => {
            addRangeRow(0);
          }}
        />
      </div>
      <div style={{ width: "100%", overflow: "auto" }}>
        <ClassicTable>
          <Table sx={{ minWidth: 660 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                {readingColumns?.map((column) => (
                  <TableCell key={column.field}> {column.headerName}</TableCell>
                ))}
                {(permissions.delete || permissions.allAccess) && (
                  <TableCell>Actions</TableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {contactDetailsRows.map((row, index) => (
                <TableRow key={index}>
                  <TableCell>{index + 1}</TableCell>
                  {row.map((cell, cellIndex) => (
                    <TableCell key={cellIndex}>
                      <TextField
                        id="client_edit_contvalue"
                        size="small"
                        inputProps={{
                          autoComplete: "off",
                        }}
                        value={cell}
                        onChange={(e) => {
                          updateCellValue(index, cellIndex, e.target.value);
                        }}
                        type={cellIndex == 3 ? "email" : "text"}
                        inputMode={cellIndex == 2 ? "numeric" : undefined}
                        maxLength={cellIndex == 2 ? 10 : undefined}
                        error={
                          readingColumns[cellIndex + 1].validate &&
                          !readingColumns[cellIndex + 1].validate(cell)
                        }
                        helperText={
                          readingColumns[cellIndex + 1].errorText &&
                            !readingColumns[cellIndex + 1].validate(cell)
                            ? readingColumns[cellIndex + 1].errorText
                            : ""
                        }
                      />
                    </TableCell>
                  ))}
                  {(permissions.delete || permissions.allAccess) && (
                    <TableCell>
                      <DeleteIcon
                        id="client_edit_contdelte"
                        style={{ color: "#dc3545", cursor: "pointer" }}
                        onClick={(e) => {
                          deleteReadingRow(index);
                        }}
                      />
                    </TableCell>
                  )}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </ClassicTable>
      </div>
      <br />
      <div className="flex gap-10 mt-5 justify-end ">
        <CancelButton
          id="btn-cancel"
          label="Cancel"
          outline
          onClick={() => {
            if (window.confirm("Are you sure you want to cancel?")) {
              window.history.back();
            }
          }}
        />
        {(permissions.save || permissions.create || permissions.allAccess) && (
          <SaveAndUpdate
            id="btn-add-outline"
            label={params.id == 0 ? "Save" : "Update"}
            onClick={handleSave}
          />
        )}
      </div>
      <ToastContainer />
    </>
  );
};

export default EditClientMaster;
